module.exports = __webpack_public_path__ + "img/ico-globe.f6e3ea6.svg";